import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('issuer_period_audience_publishing', '/issuer_period_audience_publishings')
const actions = generator.generate()

export default actions
